import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text,
} from '@chakra-ui/react';
import { withNamespaces } from 'react-i18next';
import { setNavTab } from '../../redux/actions';
import { getCurrentNavTab } from '../../redux/selectors';
import { ACTIVE_SETTING_TAB } from '../../redux/constants';
import { NORMAL_MAX_AGE } from '../../constants'

import Header from '../Home/Header';
import Navbar from '../Home/Navbar';

import CompaniesComponent from './Settings/Companies';
import DoctorsComponent from './Settings/Doctors';
import DepartmentsComponent from './Settings/Departments';
import PatientsComponent from './Settings/Patients';
import ServicePricesComponent from './Settings/ServicePrices';
import MedicinesComponent from './Settings/Medicines';
import EnterprisesComponent from './Settings/Enterprises';
import UsersComponent from './Settings/Users';
import UserLogsComponent from './Settings/UserLogs';
import SystemsComponent from './Settings/Systems';
import PaymentLogsComponent from './Settings/PaymentLogs';

function Settings(props) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie", "selectedClinic", "settingCookies"]);
    const [selectedSetting, setSelectedSetting] = useState("TAI_KHOAN");

    const mounted = useRef();
    const t = props.t;

    useEffect(() => {
        if(!mounted.current) {
            mounted.current = true;
            props.setNavTab(ACTIVE_SETTING_TAB);
            if(cookies?.settingCookies?.data?.selectedSetting) {
                setSelectedSetting(cookies?.settingCookies?.data?.selectedSetting);
            }
        }
    });

    return (
        <React.Fragment>
            <Box>
                <Header />
                <Navbar />

                <Box w="100vw" py={{ base: 0, md: 0, lg: 0 }}>
                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" px={4} py={4} borderBottomWidth="2px" justify="flex-start" gap={2}>
                        {
                            (cookies.loginCookie?.data?.roles === "super_admin") &&
                            <Button borderRadius={10} bg={selectedSetting === "BENH_VIEN" ? "#689f38" : "#90a4ae"} 
                                color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                                px="4px" py="4px" mr="8px"  
                                onClick={
                                    () => {
                                        setSelectedSetting("BENH_VIEN");
                                        setCookie("settingCookies", { data: { selectedSetting: "BENH_VIEN" } }, { path: '/', maxAge: NORMAL_MAX_AGE });
                                    }
                                }
                            >
                                <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Company")}</Text>
                            </Button>
                        }

                        <Button borderRadius={10} bg={selectedSetting === "TAI_KHOAN" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("TAI_KHOAN");
                                    setCookie("settingCookies", { data: { selectedSetting: "TAI_KHOAN" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Account")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "BAC_SY" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px"  
                            onClick={
                                () => {
                                    setSelectedSetting("BAC_SY");           
                                    setCookie("settingCookies", { data: { selectedSetting: "BAC_SY" } }, { path: '/', maxAge: NORMAL_MAX_AGE });                     
                                }
                            }
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Doctor")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "PHONG_CHUC_NANG" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("PHONG_CHUC_NANG");
                                    setCookie("settingCookies", { data: { selectedSetting: "PHONG_CHUC_NANG" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Department_Specialist")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "BENH_NHAN" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("BENH_NHAN");
                                    setCookie("settingCookies", { data: { selectedSetting: "BENH_NHAN" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Patient")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "GIA_DICH_VU" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("GIA_DICH_VU");
                                    setCookie("settingCookies", { data: { selectedSetting: "GIA_DICH_VU" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Service")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "THUOC" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("THUOC");
                                    setCookie("settingCookies", { data: { selectedSetting: "THUOC" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Medicine")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "DOANH_NGHIEP" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("DOANH_NGHIEP");
                                    setCookie("settingCookies", { data: { selectedSetting: "DOANH_NGHIEP" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Enterprise")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "PAYMENT" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("PAYMENT");
                                    setCookie("settingCookies", { data: { selectedSetting: "PAYMENT" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Payment")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "LOGS" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("LOGS");
                                    setCookie("settingCookies", { data: { selectedSetting: "LOGS" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("Logs")}</Text>
                        </Button>

                        <Button borderRadius={10} bg={selectedSetting === "HE_THONG" ? "#689f38" : "#90a4ae"} 
                            color="black" width={{ base: "100%", md: "15%", lg: "15%" }} height={12} 
                            px="4px" py="4px" mr="8px" 
                            onClick={
                                () => {
                                    setSelectedSetting("HE_THONG");
                                    setCookie("settingCookies", { data: { selectedSetting: "HE_THONG" } }, { path: '/', maxAge: NORMAL_MAX_AGE });   
                                }
                            } 
                        >
                            <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="600">{t("System")}</Text>
                        </Button>
                    </Flex>
                    { selectedSetting === "BENH_VIEN" && <CompaniesComponent /> }
                    { selectedSetting === "TAI_KHOAN" && <UsersComponent /> }
                    { selectedSetting === "BAC_SY" && <DoctorsComponent /> }
                    { selectedSetting === "PHONG_CHUC_NANG" && <DepartmentsComponent /> }
                    { selectedSetting === "BENH_NHAN" && <PatientsComponent /> }
                    { selectedSetting === "GIA_DICH_VU" && <ServicePricesComponent /> }
                    { selectedSetting === "THUOC" && <MedicinesComponent /> }
                    { selectedSetting === "DOANH_NGHIEP" && <EnterprisesComponent setSelectedSetting={setSelectedSetting}/> }
                    { selectedSetting === "PAYMENT" && <PaymentLogsComponent /> }
                    { selectedSetting === "LOGS" && <UserLogsComponent /> }
                    { selectedSetting === "HE_THONG" && <SystemsComponent /> }
                </Box>
            </Box>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const currentNavTab             =           getCurrentNavTab(state);

    return { currentNavTab };
}

export default connect(mapStateToProps, { setNavTab })(withNamespaces()(Settings));